import PropTypes from 'prop-types'
import React, { useCallback, useRef } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { bindActionCreators } from 'redux'
import TextField from 'components/common/textfield'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import searchModalDuck from 'components/search/search-section/duck'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import { goToSearchPage, storeTheSearchWord } from '../utils'
import styles from './style.scss'
import searchCopy from '../copy'

export const HEADER_SEARCH_FORM_ID = 'header-search-form'

export const SearchForm = ({
  alwaysShowClose,
  i18n,
  placeholder,
  searchWord,
  setSearchWord,
  t,
  toggleSearchModal,
}) => {
  const searchBoxPlaceholder =
    placeholder || t('What are you looking for today?...')
  const inputRef = useRef(null)
  const bindInput = useCallback((input) => {
    inputRef.current = input
  }, [])
  const clearSearch = () => {
    setSearchWord('')
    inputRef.current?.focus()
  }

  const search = (e) => {
    e?.preventDefault()

    // Do searching for a non-empty field.
    if (searchWord) {
      storeTheSearchWord(searchWord, setSearchWord)
      goToSearchPage(searchWord, toggleSearchModal)
    }
  }

  return (
    <form
      className="search-form-container flex-form"
      id={HEADER_SEARCH_FORM_ID}
      onSubmit={search}
    >
      <style jsx>{styles}</style>
      <TextField
        fullWidth
        inputRef={bindInput}
        onChange={(e) => e && setSearchWord(e.target.value)}
        value={searchWord}
        placeholder={searchBoxPlaceholder}
        prefix={<Icon src={ICONS.search} size={ICON_SIZE.medium} />}
        postfix={
          searchWord ? (
            <button
              type="button"
              className="search-clear"
              aria-label={searchCopy(t, i18n?.language, 'clear')}
              onMouseDown={(e) => e.preventDefault()}
              onClick={clearSearch}
            >
              <Icon src={ICONS.close} size={ICON_SIZE.small} />
            </button>
          ) : undefined
        }
        typo={Typo.body2}
      />
      {alwaysShowClose && (
        <button
          type="button"
          className="search-close"
          onClick={toggleSearchModal}
          aria-label={searchCopy(t, i18n?.language, 'close')}
        >
          {searchCopy(t, i18n?.language, 'closeLabel')}
        </button>
      )}
    </form>
  )
}

SearchForm.propTypes = {
  alwaysShowClose: PropTypes.bool,
  i18n: PropTypes.shape({ language: PropTypes.string }),
  placeholder: PropTypes.string,
  searchWord: PropTypes.string,
  setSearchWord: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  toggleSearchModal: PropTypes.func.isRequired,
}

SearchForm.defaultProps = {
  alwaysShowClose: false,
  i18n: undefined,
  placeholder: '',
  searchWord: '',
}

export default compose(
  connect(
    () => ({}),
    (dispatch) =>
      bindActionCreators(
        {
          toggleSearchModal: searchModalDuck.creators.toggleSearchModal,
        },
        dispatch,
      ),
  ),
  withI18next(),
)(SearchForm)
